import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../shared/services/common/common.service';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.css']
})
export class TermsConditionComponent implements OnInit {

  TermsOfUse: any;
  constructor(private commonService: CommonService) { }
  ngOnInit() {
    this.fn_GetPrivacyPolicy();
  }
  fn_GetPrivacyPolicy() {
    this.commonService.getPrivacyPolicyAndTermsofUse().subscribe((res: any) => {
      if (res.StatusCode === 200) {
        if (res.Data.ResponseData != null) {
          this.TermsOfUse = res.Data.ResponseData[1];
        }
      }
    }, (err: any) => {
    });
  }

}
